import { defineComponent, onBeforeUnmount, onMounted, ref, } from 'vue';
import ServicePair from './ServicePair.vue';
import polaroid1 from '@/assets/polaroids/p1.jpg';
import polaroid2 from '@/assets/polaroids/p2.jpg';
import polaroid3 from '@/assets/polaroids/p3.jpg';
export default defineComponent({
    name: 'Services',
    components: { ServicePair },
    setup() {
        const skeletonsHost = ref(null);
        const unfolded = ref(false);
        const polaroidsHost = ref(null);
        const polaroidsUnfolded = ref(false);
        let observer = null;
        let polaroidObserver = null;
        onMounted(() => {
            if (skeletonsHost.value) {
                observer = new IntersectionObserver(([entry]) => {
                    if (entry.isIntersecting) {
                        unfolded.value = true;
                        observer?.disconnect();
                    }
                }, { threshold: 0.25 });
                observer.observe(skeletonsHost.value);
            }
            if (polaroidsHost.value) {
                polaroidObserver = new IntersectionObserver(([entry]) => {
                    if (entry.isIntersecting) {
                        polaroidsUnfolded.value = true;
                        polaroidObserver?.disconnect();
                    }
                }, { threshold: 0.25 });
                polaroidObserver.observe(polaroidsHost.value);
            }
        });
        onBeforeUnmount(() => {
            observer?.disconnect();
            polaroidObserver?.disconnect();
        });
        return {
            skeletonsHost,
            unfolded,
            polaroidsHost,
            polaroidsUnfolded,
            polaroid1,
            polaroid2,
            polaroid3,
        };
    },
});
